import * as React from 'react'

import { PLAYER_STATUS, PlayerStatus } from './constants'
import { CloseIcon, PauseIcon, PlayIcon, RestartIcon } from './speechIcons'

interface ReadAloudPlayerBarProps {
  className?: string;
  controlsId?: string;
  cycleRate: () => void;
  onExit: () => void;
  pause: () => void;
  play: () => void;
  rate: number;
  rewind: () => void;
  status: PlayerStatus;
}

const statusMessage = (status: PlayerStatus, rate: number) => {
  if (status === PLAYER_STATUS.PLAYING) { return `Playing at ${rate}x speed` }
  if (status === PLAYER_STATUS.PAUSED) { return 'Paused' }
  return 'Stopped'
}

const ReadAloudPlayerBar = ({ className, controlsId, cycleRate, onExit, pause, play, rate, rewind, status, }: ReadAloudPlayerBarProps) => {
  const isPlaying = status === PLAYER_STATUS.PLAYING

  const handlePlayPauseClick = () => {
    if (isPlaying) {
      pause()
    } else {
      play()
    }
  }

  return (
    <div aria-label="Read aloud player" className={`read-aloud-player ${className || ''}`} role="group">
      <span aria-live="polite" className="sr-only">{statusMessage(status, rate)}</span>
      <button aria-controls={controlsId} aria-label="Restart from the beginning" className="read-aloud-button interactive-wrapper focus-on-light" onClick={rewind} type="button">
        <RestartIcon />
      </button>
      <button aria-controls={controlsId} aria-label={isPlaying ? 'Pause read aloud' : 'Play read aloud'} className="read-aloud-button interactive-wrapper focus-on-light" onClick={handlePlayPauseClick} type="button">
        {isPlaying ? <PauseIcon /> : <PlayIcon />}
      </button>
      <button aria-label={`Reading speed: ${rate}x`} className="read-aloud-speed interactive-wrapper focus-on-light" onClick={cycleRate} type="button">
        {rate}x
      </button>
      <button aria-label="Close read aloud" className="read-aloud-button read-aloud-exit interactive-wrapper focus-on-light" onClick={onExit} type="button">
        <CloseIcon />
      </button>
    </div>
  )
}

export { ReadAloudPlayerBar }
